import { useMessages, useConfig, useAppState } from '@ynap/immutables-provider';
import { productSelectors } from '@ynap/product-state';
import { pdpSelectors } from '@ynap/product-details-state';

const configSelector = (config) => ({
    availableImageSizes: config?.head?.availableImageSizes,
    imageQuality: config?.head?.imageQualityPercentage,
    pdpUrlTemplate: config?.global?.urlConfig?.pdp?.construct,
    badgeBlocklist: config?.head?.pdp?.badgeBlocklist,
});

export const useToRecommendedProduct = () => {
    const { pdpUrlTemplate, availableImageSizes, imageQuality, badgeBlocklist } = useConfig(configSelector);
    const { locale } = useAppState();
    const messages = useMessages();

    const { getMappedProduct } = productSelectors;
    const { getProductColours } = pdpSelectors;
    return (product) => {
        product.productColours = getProductColours(product);
        const selectedProductColour = product.productColours?.find((c) => c.selected) ?? {};

        const result = getMappedProduct({
            id: product.productId,
            product: {
                ...product,
                ...selectedProductColour,
            },
            badgeBlocklist,
            locale,
            availableImageSizes,
            pdpUrlTemplate,
            imageQuality,
            pageType: '',
            messages,
        });

        const { imgSrc, designerName, name, partNumber, href, price, badge, analyticsAttributes, consideredBadge } = result;

        return { image: imgSrc, designer: designerName, description: name, partNumber, href, price, badge, analyticsAttributes, consideredBadge };
    };
};
